<template>
  <div class="search-box">
    <van-search v-model="value" @input="getSearchResult" placeholder="搜索" />
    <ul v-if=" searchResult">
      <li class="search-result" v-for="item in searchResult" @click="getSearchResult" :key="item">{{item}}</li>

    </ul>
    <div v-if="searchResult && searchResult.length == 0">
      <img class="no-data-img" src="../../assets/index/no_list.png" alt="">
      <div class="no-data-text">暂无可搜索数据哦！</div>
    </div>

    <ul class="popular-search" v-if="searchShow && historyList.length!=0">
      <li class="popular-title">历史搜索</li>
      <li class="popular-item" @click="getPopular(item.keyword)" v-for="item in  historyList" :key="item.id"> {{item.keyword}}</li>
    </ul>
    <ul class="popular-search" v-if="searchShow && !searchResult">
      <li class="popular-title">热门搜索</li>
      <li class="popular-item" @click="getPopular(item.keyword)" v-for="item in searchShow.hotKeywordList" :key="item.id"> {{item.keyword}}</li>
    </ul>
    <div class="item-box" v-if="isShowResult && goodsList.length != 0">
      <van-row class="list">
        <!-- <div v-for="(item,i) in newProduct" :key="i">111</div> -->
        <!-- <coupon v-for="(item,index) in newProduct" :key="index" :coupinItem="item"></coupon> -->
        <van-tabs v-model="active" @click="onClick">
          <van-tab title="综合排序"></van-tab>
          <van-tab>
            <template #title>
              <div class="sort-box">
                <div>价格排序</div>
                <div class="select-icon" :style="{backgroundImage:`url(${require('../../assets/index/'+selectImg)})`}"></div>
                <!-- <img class="select-icon" :src="require(selectImg)" /> -->

              </div>
            </template>
          </van-tab>
          <van-tab title="查看分类">
            <van-row class="type-box" gutter="20">
              <van-col @click="getCatalog(item.id)" class="type-item" v-for="(item,index) in filterCategoryList" :key="index" span="4">{{item.name}}</van-col>
            </van-row>
          </van-tab>
        </van-tabs>
        <itemInfo @navDetail="navToDetail" v-for="(itemInfo,index) in goodsList" :key="index" :itemInfo=itemInfo></itemInfo>

      </van-row>

    </div>
    <div v-if="searchResult==null && isShowResult && goodsList.length == 0">
      <img class="no-data-img" src="../../assets/index/no_list.png" alt="">
      <div class="no-data-text">暂无可搜索数据哦！</div>
    </div>
  </div>

</template>

<script>
import { searchInfo, searchHelper, getTypeList } from "@/api/index";
import itemInfo from "@/components/itemInfo";
// import { Dialog } from "vant";
export default {
  name: "searchPage",
  components: {
    itemInfo,
  },
  data() {
    return {
      isShowResult: false,
      active: 0,

      value: "",
      selectImg: "select_icon.png",

      placeholderUi: "请输入搜索关键词",
      searchShow: null,
      searchResult: null,
      tabClickTime: 0,
      historyList: "",

      data: {
        keyword: "", //	搜索内容	是	[string]
        page: 1, //页码	是	[string]
        size: 10, //大小	是	[string]
        sort: "name", //name:综合,retail_price:价格	是	[string]
        order: "asc", //desc倒叙,asc正序	是	[string]
        categoryId: 0, //类型id,没有时传0	是	[string]
      },
      isLoading: true,
      loading: false,
      finished: false,
      goodsList: [],
      filterCategoryList: null,
    };
  },
  created() {
    this.getSearchInfo();
  },
  methods: {
    // onClick(idx) {
    //   switch (idx) {
    //     case 0:
    //       this.data = {
    //         keyword: this.value,
    //         page: 1, //	页码	是	[string]	1	查看
    //         size: 10, //大小	是	[string]	100	查看
    //         order: " asc", //排序	是	[string]	desc倒叙 asc正序	查看
    //         sort: "name", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
    //         categoryId: 0
    //       };
    //       this.getList(this.data);
    //       break;
    //     case 1:
    //       this.data = {
    //         keyword: this.value,
    //         page: 1, //	页码	是	[string]	1	查看
    //         size: 10, //大小	是	[string]	100	查看
    //         order: "asc", //排序	是	[string]	desc倒叙 asc正序	查看
    //         sort: "name", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
    //         categoryId: 0
    //       };
    //       this.getList(this.data);
    //       break;
    //     default:
    //       break;
    //   }
    // },
    onClick(idx, title) {
      console.log(idx, title);
      switch (idx) {
        case 0:
          this.tabClickTime = 0;
          this.selectImg = "select_icon.png";
          this.data = {
            keyword: this.value, //	是否新品	是	[string]	true	查看
            page: 1, //	页码	是	[string]	1	查看
            size: 10, //大小	是	[string]	100	查看
            order: "desc", //排序	是	[string]	desc倒叙 asc正序	查看
            sort: "add_time", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
            categoryId: 0,
          };
          this.getList(this.data);
          break;
        case 1:
          this.tabClickTime += 1;
          if (this.tabClickTime > 1) {
            this.tabClickTime = 0;
            this.data = {
              keyword: this.value, //	是否新品	是	[string]	true	查看
              page: 1, //	页码	是	[string]	1	查看
              size: 10, //大小	是	[string]	100	查看
              order: "desc", //排序	是	[string]	desc倒叙 asc正序	查看
              sort: "retail_price", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
              categoryId: 0,
            };
            this.selectImg = "select_bottom.png";
            this.getList(this.data);
          } else {
            this.data = {
              keyword: this.value, //	是否新品	是	[string]	true	查看
              page: 1, //	页码	是	[string]	1	查看
              size: 10, //大小	是	[string]	100	查看
              order: "asc", //排序	是	[string]	desc倒叙 asc正序	查看
              sort: "retail_price", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
              categoryId: 0,
            };
            this.selectImg = "select_top.png";
            this.getList(this.data);
          }
          break;
        case 2:
          this.tabClickTime = 0;
          this.selectImg = "select_icon.png";
          break;
        default:
          break;
      }
    },
    navToDetail(id) {
      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id,
        },
      });
    },
    getList(data) {
      this.filterCategoryList = null;
      getTypeList(data).then((res) => {
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          // this.newProduct = this.newProduct.concat(newOfRes.newProduct);
          this.goodsList = newOfRes.goodsList;
          this.filterCategoryList = newOfRes.filterCategoryList;
          // this.loading = false;
          // 数据全部加载完成
          // if (this.newProduct.length == newOfRes.count) {
          //   this.finished = true;
          // }
        }
      });
    },
    getCatalog(id) {
      this.data.categoryId = id;
      this.getList(this.data);
    },
    getSearchResult() {
      this.isShowResult = true;
      this.searchShow = null;
      this.searchResult = null;
      this.data.keyword = this.value;
      getTypeList(this.data).then((res) => {
        this.filterCategoryList = res.data.data.filterCategoryList;
        this.goodsList = res.data.data.goodsList;
      });
    },
    getPopular(value) {
      this.value = value;
      this.isShowResult = true;
      this.searchShow = null;
      this.searchResult = null;
      this.data.keyword = value;
      getTypeList(this.data).then((res) => {
        this.filterCategoryList = res.data.data.filterCategoryList;
        this.goodsList = res.data.data.goodsList;
      });
    },

    getSearchInfo() {
      searchInfo().then((res) => {
        console.log(res);
        this.searchShow = null;
        if (res.data.errno == 0) {
          this.searchShow = res.data.data;
          this.historyList = res.data.data.historyKeywordList;

          this.placeholderUi = res.data.data.defaultKeyword.keyword;
        }
      });
    },
    searchEvent(value) {
      this.goodsList = [];
      this.searchResult = [];
      searchHelper(value).then((res) => {
        if (res.data.errno == 0) {
          this.searchResult = res.data.data;
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.search-box {
  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;
  padding-bottom: 5rem;
  box-sizing: border-box;
  .no-data-img {
    width: 74%;
    margin: 6rem auto;
  }
  .no-data-text {
    font-family: PingFangSC-Semibold;
    font-size: 1.8rem;
    color: #424242;
    letter-spacing: 0;
    line-height: 1.8rem;
  }
  .search-result {
    text-align: left;
    padding-left: 2rem;
  }
  .popular-search {
    text-align: left;
    padding-left: 2rem;

    .popular-title {
      margin: 1rem 0;
    }
    .popular-item {
      border: 1px solid #999;
      padding: 0.3rem 0.5rem;
      display: inline-block;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
  }
}
.item-box {
  width: 100%;
  // margin-top: 2rem;
  padding-bottom: 1rem;

  .list {
    width: 100%;
    margin: 0 auto;
    background: #fff;
    .type-box {
      width: 100%;
      background: #fff;
      margin: 0 !important;
      .type-item {
        border: 1px solid #eee;
        padding: 0.5rem 1rem;
        margin: 0.6rem;
      }
    }
  }
}
.sort-box {
  display: flex;
  justify-content: center;
  align-items: center;
  .select-icon {
    width: 0.6rem;
    height: 1rem;
    margin-left: 0.5rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/type/searchPage.vue